import React from "react";
import Day from "features/CalendarView/Day";
import SelectedCircle from "features/CalendarView/SelectedCircle";
import SchedulableDayComponent from "./SchedulableDay.shared";
import GraphicCalendarNotesShared from "shared/CalendarView/GraphicCalendarNotes.shared.js";

import connect from "glassRedux/connect";
import { bindActionCreators } from "redux";
import { resolveTask, setIsChangingDayFromNonScrollEvent } from "shared/itemLists/redux/itemListsSlice";

export class DayShared extends React.Component {
  shouldComponentUpdate(prevProps) {
    return (
      prevProps.isSelected !== this.props.isSelected ||
      prevProps.isActive !== this.props.isActive ||
      prevProps.calendarNotes !== this.props.calendarNotes ||
      prevProps.itemType !== this.props.itemType ||
      prevProps.isHighlighted !== this.props.isHighlighted ||
      prevProps.itemType !== this.props.itemType ||
      prevProps.hasMonthNameSuperscript != this.props.hasMonthNameSuperscript
    );
  }

  render() {
    const { props } = this;
    const {
      isSelected,
      setSelectedDate,
      isToday,
      isActive,
      itemType,
      dateHelper,
      resolveTask,
      date,
      calendarNotes,
    } = props;

    const isInItemCal = !!itemType
    const monthName = dateHelper.shortMonthName(date.getMonth());
    const dayNumber = date.getDate();
    const isRed = isRedFunc()
    function selectedCircle() {
      return (
        <SelectedCircle
          isRed={isRed}
          isToday={isToday}
          isSelected={isSelected}
          isActive={isActive}
          itemType={itemType}
          monthName={monthName}
          dayNumber={dayNumber}
        />
      );
    }

    function isRedFunc() {
      if (calendarNotes === undefined) {
        return false;
      }
      let bool = false;
      if (calendarNotes.calendarNotes) {
        calendarNotes.calendarNotes.forEach((cn) => {
          if (cn.color_type === "red") {
            bool = true;
          }
        });
      }
      if (calendarNotes.continuingCalendarNotes) {
        calendarNotes.continuingCalendarNotes.forEach((cn) => {
          if (cn.color_type === "red") {
            bool = true;
          }
        });
      }
      return bool;
    }

    function handleDayClick(event) {
      setSelectedDate(date);
      if(!isInItemCal){ 
        props.setIsChangingDayFromNonScrollEvent(true)
      }
      resolveTask({ method: "dayClick" });
    }

    const graphicCNs = calendarNotes !== undefined && (
      <GraphicCalendarNotesShared data={calendarNotes}/>
    );

    function day(Component) {
      return (
        <Component
          {...props}
          {...{graphicCNs, monthName, handleDayClick, isRed}}
          selectedCircle={selectedCircle()}
        />
      );
    }

    if (isInItemCal) {
      return day(SchedulableDayComponent);
    } else {
      return day(Day);
    }
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resolveTask, setIsChangingDayFromNonScrollEvent }, dispatch);
}

export default connect(null, mapDispatchToProps)(DayShared);
